import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const isStringArray = data =>
    Array.isArray(data) && data.every(item => typeof item === 'string');

const isObjectArray = data =>
    Array.isArray(data) && data.every(item => item instanceof Object);

const is2DStringArray = data =>
    Array.isArray(data) && data.every(item => isStringArray(item));

const useStyles = makeStyles(theme => ({
    section: {
        paddingTop: 5,
        '&:first-child': {
            paddingRop: 0,
        },
    },
    text: {
        fontSize: '0.8125rem !important',
    },
}));

const LogDetailsSection = ({ section = {}, classes = {} }) => {
    return (
        <div className={classes.section}>
            {section.name && (
                <Typography variant="subtitle2" className={classes.text}>
                    {section.name}
                </Typography>
            )}
            {is2DStringArray(section.content) &&
                [].concat(...section.content).map(item => (
                    <Typography variant="body2" className={classes.text}>
                        {item}
                    </Typography>
                ))}
            {}
        </div>
    );
};

const LogDetails = ({ data = {} }) => {
    const isString = typeof data === 'string';
    const isObject = data instanceof Object;
    const classes = useStyles();

    return (
        <>
            {isString && data}
            {isStringArray(data) && data.join(', ')}
            {isObject && data.header && (
                <Typography variant="subtitle2" className={classes.text}>
                    {data.header}
                </Typography>
            )}
            {isObject &&
                isStringArray(data.content) &&
                data.content.map(content => (
                    <Typography variant="body2" className={classes.text}>
                        {content}
                    </Typography>
                ))}
            {isObject &&
                isObjectArray(data.sections) &&
                data.sections.map(section => (
                    <LogDetailsSection classes={classes} section={section} />
                ))}
        </>
    );
};

export { LogDetails };
